module.exports = __webpack_public_path__ + "media/banner.7504a70d.mp4";